<template>
  <v-app>
    <TheNavbar />
    <TheSidebar
      v-if="isUserLoggedIn"
      :items="sidebarItems"
    />
    <AlertList class="fixed--alert" />
    <v-content>
      <NoIDCard v-if="!getCompany" />
      <v-slide-x-transition mode="out-in">
        <router-view v-if="getCompany" />
      </v-slide-x-transition>
    </v-content>
    <confirm ref="confirm" />
    <Msg ref="Msg" />
  </v-app>
</template>

<script>
import TheNavbar from './components/globals/TheNavbar'
import TheSidebar from './components/globals/TheSidebar'
import NoIDCard from './components/globals/NoIDCard'
import confirm from './components/globals/Confirm'
import Msg from './components/globals/Msg'
import { mapGetters } from 'vuex'
import AlertList from './plugins/MyAlert/AlertList'

export default {
  name: 'App',
  components: {
    AlertList,
    TheSidebar,
    TheNavbar,
    NoIDCard,
    confirm,
    Msg
  },
  data () {
    return {
      sidebarItems: [
        {
          title: 'Nuevo Turno',
          path: '/seleccion',
          icon: 'add'
        },
        {
          title: 'Mis Turnos',
          path: '/turnos',
          icon: 'insert_invitation'
        },
        {
          title: 'Mis Informes',
          path: '/informes',
          icon: 'book'
        },
        {
          title: 'Mis Datos',
          path: '/configuracion',
          icon: 'settings'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isUserLoggedIn', 'getCompany'])
  },
  mounted () {
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$Msg = this.$refs.Msg.open
  }
}
</script>

<style lang="sass">
h1,h2,h3,h4
  color: #0b0b0b

.progress-circle
  margin: 40vh auto

.fixed--alert
  position: fixed
  width: 100%
  z-index: 1000
</style>
